import React, { useState, useRef } from 'react';

import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

import {
    Button, Dialog, Grid, Icon, DialogTitle,
    DialogContent, DialogActions, Typography,
} from '@material-ui/core'
import { useEffect } from 'react';
import CloseIcon from "@material-ui/icons/Close";
import useStyles from "./styles";
import Scrollbars from "rc-scrollbars";
function ImageCropDialog({ src, fieldName, onClose, onSave, open }) {

    const classes = useStyles();

    const [crop, setCrop] = useState({
        aspect: 16 / 9,
    });
    const handleImgloaded = img => {

        imageRef.current = img

    }
    const [enableSave, setEnableSave] = useState(false);


    const [croppedImage, setCroppedImage] = useState(null); // To store the cropped image data URL

    const imageRef = useRef(null);

    const handleSave = () => {
        const croppedImageUrl = getCroppedImageURL();
        onSave(croppedImageUrl, fieldName);
    };

    const getCroppedImageURL = () => {
        if (imageRef.current && crop.width && crop.height) {
            const canvas = document.createElement('canvas');
            canvas.width = crop.width;
            canvas.height = crop.height;
            const ctx = canvas.getContext('2d');

            // Ensure the image is loaded before drawing
            if (imageRef.current.complete) {
                const scaleX = imageRef.current.naturalWidth / imageRef.current.width;
                const scaleY = imageRef.current.naturalHeight / imageRef.current.height;

                ctx.drawImage(
                    imageRef.current,
                    crop.x * scaleX,
                    crop.y * scaleY,
                    crop.width * scaleX,
                    crop.height * scaleY,
                    0,
                    0,
                    crop.width,
                    crop.height
                );

                // Convert the cropped canvas to a data URL
                const croppedImageUrl = canvas.toDataURL('image/jpeg');
                setCroppedImage(croppedImageUrl);
                return croppedImageUrl;
            } else {
                console.error('Image not loaded');
            }
        }
    };
    const handleSetCrop = (newCrop) => {
        setEnableSave(true);
        setCrop(newCrop)
    }
    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <div className={classes.box}>
                <div className={classes.header} id="draggable-dialog-title">
                    <Typography className={classes.title}>Crop Image</Typography>

                    <Icon
                        className={classes.closeIcon}
                        onClick={onClose}
                        color="primary"
                    >
                        <CloseIcon />
                    </Icon>
                </div>

                <DialogContent>

                    <ReactCrop
                        crop={crop}
                        onChange={newCrop => handleSetCrop(newCrop)}
                        //onComplete={handleImgloaded}
                        onImageLoaded={handleImgloaded}
                    >
                        <img src={src} ref={imageRef} />
                    </ReactCrop>

                </DialogContent>

                <div className={classes.footer}>
                    <div className={classes.footerRight}>
                        <Button onClick={onClose} className={classes.backBtn}>
                            Cancel
                        </Button>
                        <Button onClick={handleSave} className={classes.changeBtn} disabled={!enableSave}>
                            Save
                        </Button>
                    </div>
                </div>

            </div>
        </Dialog>
    );
}

export default ImageCropDialog;